import Tile from './Tile'

const LAYOUT = [
  ['EURUSD', 'GBPUSD', 'USDJPY', 'CL'],
  ['USDCAD', 'USDCHF', 'AUDUSD', 'GC'],
  ['NZDUSD', 'EURGBP', 'GBPJPY', 'BTCUSD'],
]

export default function Layout() {
  return (
    <div className="mx-auto flex w-full min-w-[60rem] max-w-[70rem] grow flex-col">
      {LAYOUT.map((row, ri) => (
        <div key={ri} className="flex grow flex-row">
          {row.map((ticker) => (
            <Tile ticker={ticker} key={ticker} hoverOffsetX={0} hoverOffsetY={25} />
          ))}
        </div>
      ))}
    </div>
  )
}
